import React, { useState, useEffect } from 'react';

// Training Guide Data
const trainingGuides = [
    {
        id: 'new-signups',
        icon: '🆕',
        title: 'New Signups Workflow',
        category: 'Onboarding',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Step-by-Step Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Click approve after checking the details</li>
                        <li>It will move the customer to customer tab</li>
                        <li>Confirm the payment</li>
                        <li>If the customer made the payment mark him paid</li>
                        <li>Find customer route and stop no in road warrior app</li>
                        <li>Go to dispatching tab</li>
                        <li>Set Route, Preference, Avoid, Pkg Inst, Bags</li>
                        <li>Go to driver tab</li>
                        <li>Select route and reorder customer</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-address',
        icon: '📍',
        title: 'Update Request: Change Address',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Copy address instructions</li>
                        <li>Go to customer dashboard</li>
                        <li>Search customer</li>
                        <li>Click edit</li>
                        <li>Change address</li>
                        <li>Save changes</li>
                        <li>Set new route and stop no in road warrior app</li>
                        <li>Go to dispatch tab</li>
                        <li>Assign new route</li>
                        <li>Go to driver dashboard</li>
                        <li>Reorder stop</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-phone',
        icon: '📱',
        title: 'Update Request: Change Phone Number',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Copy Phone No</li>
                        <li>Go to customer dashboard</li>
                        <li>Search customer</li>
                        <li>Click edit</li>
                        <li>Change no.</li>
                        <li>Save changes</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-delivery',
        icon: '🚚',
        title: 'Update Request: Update Delivery Instructions',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Copy instructions</li>
                        <li>Go to customer dashboard</li>
                        <li>Search customer</li>
                        <li>Click edit</li>
                        <li>Change delivery instruction</li>
                        <li>Save changes</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-preferences',
        icon: '🥗',
        title: 'Update Request: Update Food Preferences',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Copy preference</li>
                        <li>Go to dispatching tab</li>
                        <li>Search customer</li>
                        <li>Select edit</li>
                        <li>Make changes and save</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-pause',
        icon: '⏸️',
        title: 'Update Request: Pause Plan',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Note pause date</li>
                        <li>Go to Customer tab</li>
                        <li>Locate customer</li>
                        <li>Click Pause</li>
                        <li>Select date or date range</li>
                        <li>Save changes</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-continue',
        icon: '▶️',
        title: 'Update Request: Continue Plan',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Note plan continue date</li>
                        <li>Go to Customer tab</li>
                        <li>Locate customer</li>
                        <li>Click Un-pause (renewal date should be automatically set but still reconfirm)</li>
                        <li>Go to Update Request Dashboard</li>
                        <li>Click Approve button</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'update-feedback',
        icon: '💬',
        title: 'Update Request: Delivery or Food Feedback',
        category: 'Update Requests',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Action Required
                    </h4>
                    <p className="text-gray-700">
                        Please share the issue with respective associate and if necessary update the instructions in packaging dashboard.
                    </p>
                </div>
            </div>
        )
    },
    {
        id: 'renewals-reminder',
        icon: '📧',
        title: 'Renewals: Sending Renewal Reminder',
        category: 'Renewals',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Go to renewals tab due today or over due</li>
                        <li>Click Send Renewal Reminder</li>
                        <li>This will notify customer about their renewal</li>
                    </ol>
                    <div className="mt-4 p-3 bg-gray-100 rounded border border-gray-300">
                        <h5 className="font-bold text-gray-900 mb-2 flex items-center gap-2">
                            <span className="text-orange-500">✅</span> Customer Has 3 Options:
                        </h5>
                        <ul className="list-disc list-inside text-gray-700 space-y-1">
                            <li>Scenario 1: Renew Same Plan</li>
                            <li>Scenario 2: Change Plan</li>
                            <li>Scenario 3: Cancel Subscription</li>
                        </ul>
                        <p className="mt-2 text-sm text-gray-600">Each response will move the customer from due today or overdue to response tab once they responded</p>
                    </div>
                </div>
            </div>
        )
    },
    {
        id: 'renewals-same',
        icon: '🔄',
        title: 'Renewals: Scenario 1 - Renew Same Plan',
        category: 'Renewals',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Click ✅ Process Response</li>
                        <li>Check Customer's Selected Dates</li>
                        <li>Checkbox pause customer if start date in future</li>
                        <li>Checkbox mark as paid if paid or later in customer tab if not yet received but remember to update later in customer tab</li>
                        <li>Click Submit & Update Customer</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'renewals-change',
        icon: '📝',
        title: 'Renewals: Scenario 2 - Change Plan',
        category: 'Renewals',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Click ✅ Process Response</li>
                        <li>Check new plan change and pricing</li>
                        <li>Checkbox pause customer if start date in future</li>
                        <li>Checkbox mark as paid if paid or later in customer tab if not yet received but remember to update later in customer tab</li>
                        <li>Click Submit & Update Customer</li>
                        <li>Verify the change in customer tab</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'renewals-cancel',
        icon: '❌',
        title: 'Renewals: Scenario 3 - Cancel Subscription',
        category: 'Renewals',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Click ✅ Process Response</li>
                        <li>Click cancel subscription</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'ex-clients',
        icon: '👤',
        title: 'Ex-Client Tab',
        category: 'Customer Management',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Functions
                    </h4>
                    <p className="text-gray-800 mb-3">You will find all the ex customers here. You have two options:</p>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        <li><strong>Delete customer forever</strong> - Permanently remove from system</li>
                        <li><strong>Re-activate the customer</strong> - In case you have cancelled the customer in customer tab by mistake (you will have to make sure all columns in customer tab are correct)</li>
                    </ul>
                </div>
            </div>
        )
    },
    {
        id: 'income-expenses',
        icon: '💰',
        title: 'Income & Expenses',
        category: 'Financial',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Recording Income
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Go to income and expense tab</li>
                        <li>Record income payment if customer made any specific payment for extra service or past due amount</li>
                        <li><strong>Don't record payment</strong> if you mark paid customer in customer tab or renewal or change plan form upon subscription renewal</li>
                    </ol>
                    <h4 className="font-bold text-gray-900 mb-3 mt-4 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Record Expense
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Select category or create one if not already</li>
                        <li>Enter amount</li>
                        <li>Expense date</li>
                        <li>Payment Method (Optional)</li>
                        <li>Record expense</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'messages-quote',
        icon: '⚡',
        title: 'Message Tab: Today\'s Power Quote',
        category: 'Communication',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Find a quote of the day</li>
                        <li>Paste</li>
                        <li>Click Set Power Quote</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'messages-personal',
        icon: '📧',
        title: 'Message Tab: Send Message to Selected Customer',
        category: 'Communication',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Select customer</li>
                        <li>Write message</li>
                        <li>Click Send Personal Message</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'messages-broadcast',
        icon: '📢',
        title: 'Message Tab: Broadcast Message to All Customers',
        category: 'Communication',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> Process
                    </h4>
                    <ol className="list-decimal list-inside space-y-2 text-gray-700">
                        <li>Enter broadcast message</li>
                        <li>Select expiry date (the message will disappear on that day)</li>
                        <li>Click Send Broadcast</li>
                    </ol>
                </div>
            </div>
        )
    },
    {
        id: 'preferences',
        icon: '⚙️',
        title: 'Preferences Tab',
        category: 'Customer Management',
        content: (
            <div className="space-y-4">
                <div className="bg-white border-l-4 border-orange-500 p-4 rounded shadow">
                    <h4 className="font-bold text-gray-900 mb-3 flex items-center gap-2">
                        <span className="text-orange-500">📋</span> How It Works
                    </h4>
                    <ul className="list-disc list-inside space-y-2 text-gray-700">
                        <li>Customer can set preference themselves</li>
                        <li>Admin can set the preference too</li>
                        <li>Just confirm if the preferences were updated in packaging dashboard of that customer as well</li>
                    </ul>
                </div>
            </div>
        )
    }
];

// Helper: Icon mapper
const getGuideIcon = (emoji) => {
    const iconMap = {
        '🆕': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>,
        '📍': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /></svg>,
        '📱': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>,
        '🚚': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>,
        '🥗': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>,
        '⏸️': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
        '▶️': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
        '💬': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>,
        '📧': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>,
        '🔄': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>,
        '📝': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
        '❌': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
        '👤': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
        '💰': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
        '⚡': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>,
        '📢': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" /></svg>,
        '⚙️': <svg className="h-8 w-8 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
    };
    return iconMap[emoji] || emoji;
};

// Sidebar Component
const TrainingGuideSidebar = ({ selectedGuideId, onClose }) => {
    const [sidebarWidth, setSidebarWidth] = useState(600);
    const [isResizing, setIsResizing] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ x: window.innerWidth - 600, y: 0 });
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    const currentGuide = trainingGuides.find(g => g.id === selectedGuideId) || trainingGuides[0];

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsResizing(true);
    };

    const handleHeaderMouseDown = (e) => {
        if (e.target.tagName === 'BUTTON') return; // Don't drag when clicking close button
        setIsDragging(true);
        setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isResizing) {
                const newWidth = window.innerWidth - e.clientX;
                if (newWidth >= 400 && newWidth <= 1200) {
                    setSidebarWidth(newWidth);
                    setPosition(prev => ({ ...prev, x: window.innerWidth - newWidth }));
                }
            } else if (isDragging) {
                const newX = e.clientX - dragStart.x;
                const newY = e.clientY - dragStart.y;

                // Keep within viewport bounds
                const maxX = window.innerWidth - sidebarWidth;
                const maxY = window.innerHeight - 100;

                setPosition({
                    x: Math.max(0, Math.min(newX, maxX)),
                    y: Math.max(0, Math.min(newY, maxY))
                });
            }
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            setIsDragging(false);
        };

        if (isResizing || isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isResizing, isDragging, dragStart, sidebarWidth]);

    return (
        <div
            className="fixed h-full bg-gray-900 border-4 border-orange-500 overflow-y-auto shadow-2xl"
            style={{
                width: `${sidebarWidth}px`,
                zIndex: 40,
                left: `${position.x}px`,
                top: `${position.y}px`,
                maxHeight: '90vh'
            }}
        >
            {/* Resize Handle - wider and more visible */}
            <div
                className="absolute left-0 top-0 w-2 h-full cursor-ew-resize hover:bg-orange-500 bg-orange-300 opacity-50 hover:opacity-100 transition-all"
                style={{ zIndex: 41 }}
                onMouseDown={handleMouseDown}
                title="Drag to resize"
            />

            {/* Header - Draggable */}
            <div
                className="bg-orange-500 p-4 flex items-center justify-between sticky top-0 z-10 cursor-move"
                onMouseDown={handleHeaderMouseDown}
            >
                <h3 className="text-white font-bold flex items-center gap-2">
                    <span className="text-2xl">{currentGuide.icon}</span>
                    <span>Training Guide</span>
                    <span className="text-xs opacity-75">(Drag to move)</span>
                </h3>
                <button
                    onClick={onClose}
                    className="text-white hover:bg-orange-600 p-2 rounded transition-colors cursor-pointer"
                >
                    ✕
                </button>
            </div>

            {/* Content */}
            <div className="p-6">
                <div className="mb-6">
                    <h2 className="text-2xl font-bold text-white mb-2">{currentGuide.title}</h2>
                    <p className="text-orange-400 text-sm">{currentGuide.category}</p>
                </div>

                {currentGuide.content}
            </div>
        </div>
    );
};

// Main Component
const TrainingGuideTab = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [selectedGuideId, setSelectedGuideId] = useState(null);

    const filteredGuides = trainingGuides.filter(guide =>
        guide.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        guide.category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-gray-900 text-white p-6">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="mb-8 bg-gradient-to-r from-black to-gray-900 rounded-xl p-6 border-2 border-orange-500 shadow-lg">
                    <h1 className="text-4xl font-bold text-white mb-2 flex items-center gap-3">
                        <svg className="h-10 w-10 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                        </svg>
                        Staff Training Guide
                    </h1>
                    <p className="text-gray-300 text-lg">Comprehensive guides for all dashboard operations</p>
                </div>

                {/* Search */}
                <div className="mb-6">
                    <input
                        type="text"
                        placeholder="Search training guides..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                </div>

                {/* Categories */}
                <div className="mb-6">
                    <div className="flex flex-wrap gap-2">
                        {['All', ...new Set(trainingGuides.map(g => g.category))].map(category => (
                            <button
                                key={category}
                                onClick={() => setSelectedCategory(category)}
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedCategory === category
                                    ? 'bg-orange-500 text-white'
                                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                    }`}
                            >
                                {category}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Training Guides Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filteredGuides
                        .filter(guide => selectedCategory === 'All' || guide.category === selectedCategory)
                        .map((guide) => (
                            <div
                                key={guide.id}
                                onClick={() => setSelectedGuideId(guide.id)}
                                className="bg-gray-800 border-2 border-gray-600 rounded-lg p-6 cursor-pointer hover:border-orange-500 transition-colors group shadow-lg"
                            >
                                <div className="mb-3">{getGuideIcon(guide.icon)}</div>
                                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-orange-500 transition-colors">
                                    {guide.title}
                                </h3>
                                <p className="text-sm text-gray-400 mb-3">{guide.category}</p>
                                <div className="text-orange-500 text-sm font-medium">
                                    Click to view guide →
                                </div>
                            </div>
                        ))}
                </div>

                {filteredGuides.filter(guide => selectedCategory === 'All' || guide.category === selectedCategory).length === 0 && (
                    <div className="text-center py-12 bg-gray-800 rounded-xl border-2 border-orange-500">
                        <svg className="mx-auto h-16 w-16 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <h3 className="text-xl font-bold text-gray-400 mb-2">No guides found</h3>
                        <p className="text-gray-500">Try adjusting your search or category filter</p>
                    </div>
                )}
            </div>

            {/* Sidebar */}
            {selectedGuideId && (
                <TrainingGuideSidebar
                    selectedGuideId={selectedGuideId}
                    onClose={() => setSelectedGuideId(null)}
                />
            )}
        </div>
    );
};

export default TrainingGuideTab;
